<template>
  <div class="bq-tab">
    <div class="bq-tab" :class="[`bq-tab-${layout}`]">
      <ul class="bq-tab-wrap" :class="[`${layout}`, isFixed]">
        <li
          :style="{ width: `${itemWidht}` }"
          class="bq-tab-item"
          v-for="(item, index) in tabs"
          :key="index"
          :class="{ active: active === index }"
          @click="handleClick(index, item)"
        >
          <img
            :class="item.class"
            :src="item.icon"
            :alt="item.title"
            v-if="isMobile"
          />
          <span v-else>{{ item.title }}</span>
        </li>
      </ul>

      <ul class="bq-tab-content" :class="isFixed">
        <li
          v-for="(item, index) in tabs"
          :key="item.title"
          v-show="index === active"
        >
          <slot :name="item.slot"></slot>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BqTab',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    isTitle: {
      type: Boolean,
      default: true,
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
    layout: {
      type: String,
      default: 'horizon',
    },
    fixedHeight: {
      // 吸顶高度
      type: Number,
      default: 770,
    },
  },

  data() {
    return {
      isMobile: false,
      active: this.activeIndex,
      isFixed: '',
    };
  },

  // mounted() {
  //   window.addEventListener('scroll', this.windowScroll);
  // },

  computed: {
    itemWidht: function() {
      return this.layout !== 'horizon'
        ? 'auto'
        : (1 / this.tabs.length) * 100 + '%';
    },
  },

  watch: {
    activeIndex: {
      handler(newValue) {
        this.active = newValue;
      },
    },
  },

  methods: {
    // windowScroll() {
    //   let scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;
    //   if (this.layout === 'vertical' && scrollTop > this.fixedHeight) {
    //     this.isFixed = 'fixed';
    //   } else {
    //     this.isFixed = '';
    //   }
    // },
    handleClick(index) {
      this.active = index;
      this.$emit('handleClick', index);
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../../assets/styles/fn.less';
.bq-tab {
  &.bq-tab-horizon {
    .bq-tab-wrap.horizon {
      height: 87px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      // box-shadow: 0px 3px 6px 0px rgba(162, 162, 162, 0.5);
      // box-shadow: 0px 3px 6px 0px rgba(183, 183, 183, 0.35);
      box-shadow: 0px 3px 10px 0px rgba(183, 183, 183, 0.2);

      .bq-tab-item {
        // width: 33%;
        text-align: center;
        line-height: 87px;
        display: inline-block;
        background-color: transparent;
        font-size: 18px;
        color: #666;
        white-space: nowrap;

        &.active {
          color: #333;
          background-color: transparent;

          span {
            position: relative;

            &::before {
              position: absolute;
              bottom: -35px;
              left: 50%;
              margin-left: -31.5px;
              content: '';
              width: 63px;
              height: 4px;
              background-color: #0d3091;
              border-radius: 3px;
            }
          }
        }
      }
    }
  }
  &.bq-tab-vertical {
    display: flex;
    margin: 0 auto;
    .w1200();

    .bq-tab-wrap {
      width: 234px;
      height: auto;
      flex-direction: column;
      border-right: 2px solid #bdbdbd;
      background-color: #fff;
      &.fixed {
        position: fixed;
        top: 80px;
      }

      .bq-tab-item {
        // padding: 30px 32px;
        // line-height: 30px;
        margin-top: 5px;
        margin-bottom: 5px;
        height: 65px;
        line-height: 65px;
        text-align: center;
        font-size: 18px;
        color: #666;
        background: rgba(255, 255, 255, 1);
        position: relative;
        transition: all 0.3s ease;
        cursor: pointer;
        &::before {
          content: '';
          position: absolute;
          right: -2px;
          height: 100%;
          width: 2px;
          background-color: #0d3091;
          transition: all 0.3s ease;
          opacity: 0;
        }

        &:last-child {
          margin-bottom: 0px;
        }

        &:first-child {
          margin-top: 0px;
        }

        &:hover,
        &.active {
          color: #0d3091;
          box-shadow: 0 2px 6px 0px rgba(183, 183, 183, 0.35);
          &::before {
            opacity: 1;
          }
        }
      }
    }

    .bq-tab-content {
      flex-basis: 966px;
      width: 966px;
      padding-left: 70px;

      &.fixed {
        position: relative;
        left: 270px;
        flex: 0 0 auto;
      }

      h3 {
        margin-bottom: 10px;
        font-size: 20px;
        text-align: center;
      }

      .bq-tab-cover {
        display: block;
        width: 100%;
        margin: 50px auto 20px;
      }
    }
  }
}
</style>
